import UserConsoleLayout from '@/views/kpi/layout/userConsoleLayout.vue';
import MulPageLayout from '@/views/kpi/layout/mul-page-layout.vue';

/**
 * 自由用户路由配置
 * @import './route.jsdoc.js'
 * @type {[Route]}
 * */
export const userRoutes = [
    {
        title: '首页',
        path: '/home',
        page: () => import('@/views/kpi/home/home.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'user' ],
        requireAuth: true,
        visible: true,
        closable: false,
        menu: [ '首页' ],
        icon: 'vxe-icon-home',
    },
    {
        title: '升级为企业用户',
        path: '/account/upgrade-enterprise',
        page: () => import('@/views/common/account/upgrade-enterprise/upgrade-enterprise.vue'),
        layout: [ MulPageLayout ],
        roles: [ 'user' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '我的组织单位',
        path: '/user/sys-setting/my-org-list',
        page: () => import('@/views/kpi/my-org/my-org-list.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'user' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '绩效编制',
        path: '/kpi/proj-kpi/home',
        page: () => import('@/views/kpi/kpi-build/home/kpi-home.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'user' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: 'AI生成指标项',
        path: '/kpi/proj-kpi/ai-create-items/:projId',
        page: () => import('@/views/kpi/kpi-build/proj-kpi/ai-create-kpi-items.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'user' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '项目绩效申报表',
        path: '/kpi/proj-kpi/declare/proj-list',
        page: () => import('@/views/kpi/kpi-build/proj-kpi/proj-kpi-list.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'user' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '绩效全过程', '项目绩效申报表' ],
        icon: [ 'vxe-icon-folder', '' ],
    },
    {
        title: '项目绩效监控',
        path: '/kpi/proj-kpi/monitor/proj-list',
        page: () => import('@/views/kpi/kpi-monitor/proj-monitor/proj-kpi/proj-kpi.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'user' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '绩效全过程', '项目绩效监控' ],
        icon: [ 'vxe-icon-folder', '' ],
    },
    {
        title: '绩效自评表',
        path: '/kpi/proj-kpi/appraise/proj-list',
        page: () => import('@/views/kpi/kpi-appraise/proj-appraise/scoring/index.vue'),
        layout: [ UserConsoleLayout ],
        requireAuth: true,
        roles: [ 'user' ],
        visible: true,
        closable: true,
        menu: [ '绩效全过程', '项目绩效自评' ],
        icon: [ 'vxe-icon-folder', '' ],
    },
    {
        title: '项目绩效监控清单',
        path: '/kpi/proj-kpi/monitor/pro-monitor-list/:projId',
        page: () => import('@/views/kpi/kpi-monitor/proj-monitor/kpi-monitor-list/kpi-monitor-list.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'user' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '项目绩效监控表',
        path: '/kpi/proj-kpi/monitor/monitor-detail/:pmId',
        page: () => import('@/views/kpi/kpi-monitor/proj-monitor/kpi-monitor/kpi-monitor.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'user' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '项目绩效自评',
        path: '/kpi/proj-kpi/appraise/appraise-home',
        page: () => import('@/views/kpi/kpi-appraise/proj-appraise/home/appraise-home.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'user' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '绩效自评表查阅',
        path: '/kpi/proj-kpi/appraise/scoring-detail/:id',
        page: () => import('@/views/kpi/kpi-appraise/proj-appraise/scoring/scoring.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'user' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '绩效自评权重设置',
        path: '/kpi/proj-kpi/appraise/weight-setting-detail/:id',
        page: () => import('@/views/kpi/kpi-appraise/proj-appraise/weight-setting/weight-setting.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'user' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '绩效自评表权重设置',
        path: '/kpi/proj-kpi/appraise/weight-setting',
        page: () => import('@/views/kpi/kpi-appraise/proj-appraise/weight-setting/index.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'user' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
];
